export default __webpack_public_path__ + "static/media/CamelBan.6304bbcc.png";